import { processInclude } from './util/common';
import GiftcardHelper from './giftcard/giftcardAddToCart';
import init from './giftcard/giftcard';

document.addEventListener('DOMContentLoaded', () => {
    init();
    processInclude(require('./giftcard/giftcardBalance'));
    processInclude(require('./checkout/giftcard'));
    GiftcardHelper.addToCart();

    $('.js-close-info-box-checkout').on('click', function () {
        $('.js-checkout-content-box-hide').hide();
    });
});
